import { AuthService } from './authService';

export interface ContactEnrichmentResult {
  companyName: string;
  website: string;
  email: string;
  phone: string;
  address: string;
  sources: string[];
  hasRequiredContact: boolean;
}

export class ContactEnrichmentService {
  static async resolve(input: {
    companyName: string;
    queryContext?: string;
    website?: string;
    location?: string;
  }): Promise<ContactEnrichmentResult | null> {
    try {
      const response = await AuthService.authFetch('/api/contact-enrichment/resolve', {
        method: 'POST',
        headers: AuthService.authHeaders(true),
        body: JSON.stringify(input),
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => null);
        console.warn('[ContactEnrichment] Resolver failed', response.status, payload);
        return null;
      }

      return await response.json();
    } catch (error) {
      console.warn('[ContactEnrichment] Resolver unavailable', error);
      return null;
    }
  }

  static async discover(input: {
    query: string;
    queryContext?: string;
    maxResults?: number;
  }): Promise<ContactEnrichmentResult[]> {
    try {
      const response = await AuthService.authFetch('/api/contact-enrichment/discover', {
        method: 'POST',
        headers: AuthService.authHeaders(true),
        body: JSON.stringify(input),
      });

      if (!response.ok) {
        const payload = await response.json().catch(() => null);
        console.warn('[ContactEnrichment] Discovery failed', response.status, payload);
        return [];
      }

      const payload = await response.json();
      return Array.isArray(payload?.leads) ? payload.leads : [];
    } catch (error) {
      console.warn('[ContactEnrichment] Discovery unavailable', error);
      return [];
    }
  }
}
